import type { ILabel } from '@ardoq/yfiles';
import { UrlLabelStyle } from 'yfilesExtensions/styles/UrlLabelStyle';
import type { GraphItem } from '@ardoq/graph';

const isUrlLabel = (label: ILabel): label is ILabel & { tag: GraphItem } => {
  return label.style === UrlLabelStyle.Instance;
};

export { isUrlLabel };
